import { render, staticRenderFns } from "./Administer.vue?vue&type=template&id=668d3574&"
import script from "./Administer.vue?vue&type=script&lang=js&"
export * from "./Administer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports